module.exports = __webpack_public_path__ + "static/media/13.6e821575.jpg";